/**
 * @generated SignedSource<<6d9f44cbd764968c97be39c4066d5fba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topStoriesHomeV2QueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryV2ContentItemContent" | "topStoriesItemV2Content">;
  };
  readonly " $fragmentType": "topStoriesHomeV2QueueItemsEdge";
}>;
export type topStoriesHomeV2QueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: topStoriesHomeV2QueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesHomeV2QueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topStoriesHomeV2QueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "topStoriesItemV2Content"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "da3b4029de5f6fdd51e8cb88af3f856c";

export default node;
